import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

import { cloneDeep } from 'lodash';

import sortingLightSvg from 'assets/svg/InventoryResult/sorting-light.svg';
import sortingdownGraySvg from 'assets/svg/InventoryResult/sortingdown-gray.svg';
import sortingdownThemeSvg from 'assets/svg/InventoryResult/sortingdown-theme.svg';
import sortingupGraySvg from 'assets/svg/InventoryResult/sortingup-gray.svg';
import sortingupThemeSvg from 'assets/svg/InventoryResult/sortingup-theme.svg';

const DND_ITEM_TYPE = 'row';

const SortingFilterDropdownItem = ({ currentSort, toggleSortBy, ...props }) => {
  const dropRef = React.useRef(null);
  const dragRef = React.useRef(null);

  const [, drop] = useDrop({
    accept: DND_ITEM_TYPE,
    hover(item, monitor) {
      if (!dropRef.current) return;

      const dragIndex = item.index;
      const hoverIndex = props.index;
      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = dropRef.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

      // move row
      const r1 = props.sortBy[dragIndex];
      let sortee = cloneDeep(props.sortBy);
      sortee = [...sortee.slice(0, dragIndex), ...sortee.slice(dragIndex + 1, sortee.length)];
      sortee = [...sortee.slice(0, hoverIndex), r1, ...sortee.slice(hoverIndex, sortee.length)];
      props.setSortBy(sortee);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: DND_ITEM_TYPE, index: props.index },
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
  });

  const opacity = isDragging ? 0 : 1;
  preview(drop(dropRef));
  drag(dragRef);

  const toggleSort = React.useCallback(() => {
    toggleSortBy(currentSort?.id, !currentSort?.desc, true);
  }, [currentSort?.desc, currentSort?.id, toggleSortBy]);

  return (
    <div ref={dropRef} style={{ opacity }} className="llSortingTitleItem">
      <span ref={dragRef} className="sqvanceImage">
        <img src={sortingLightSvg} alt="icon" />
      </span>
      <span className="selectSortingTitle">{currentSort?.title ?? currentSort?.id}</span>
      <div className="shortingRoundInner" onClick={toggleSort}>
        <img src={currentSort.desc === false ? sortingupThemeSvg : sortingupGraySvg} alt="icon" />
        <img src={!currentSort?.desc ? sortingdownThemeSvg : sortingdownGraySvg} alt="icon" />
      </div>
    </div>
  );
};

export default SortingFilterDropdownItem;
